module.exports = __webpack_public_path__ + "static/media/xckj.5927d81.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xckj.mp4
// module id = c3VY
// module chunks = 1